import React from "react";
import { createPortal } from "react-dom";
import { Save, X } from "lucide-react";

const EditFloatingActions = ({
    onSave,
    onCancel,
    disabled = false,
    saveDisabled = false,
    cancelDisabled = false,
    saveLabel = "Зберегти",
    cancelLabel = "Скасувати",
}) => {
    if (!onSave && !onCancel) return null;
    if (typeof document === "undefined" || !document.body) return null;

    return createPortal(
        <div className="edit-floating-actions edit-floating-actions--visible" role="toolbar" aria-label="Дії редагування">
            {onCancel ? (
                <button
                    type="button"
                    className="edit-floating-action is-cancel"
                    onClick={onCancel}
                    title={cancelLabel}
                    aria-label={cancelLabel}
                    disabled={disabled || cancelDisabled}
                >
                    <X size={20} />
                </button>
            ) : null}
            {onSave ? (
                <button
                    type="button"
                    className="edit-floating-action is-primary-save"
                    onClick={onSave}
                    title={saveLabel}
                    aria-label={saveLabel}
                    disabled={disabled || saveDisabled}
                >
                    <Save size={20} />
                </button>
            ) : null}
        </div>,
        document.body
    );
};

export default EditFloatingActions;
